export const fieldQualityUseCase = {
  id: 4,
  title: "Field Quality Use Case",
  activityId: 6,
  startDate: '2022-10-01',
  endDate: '2024-04-30',
  description: "Technically led a field quality usecase, integrating 12 data sources to accelerate vehicle issue resolution, applying advanced data engineering principles.",
  categorizedSkills: {
    profession: [
      { name: "Data Engineering", weight: 0.8},
      { name: "Data Analytics", weight: 0.7 },
      { name: "UI/UX Design", weight: 0.6 }
    ],
    lead: [
      { name: "Project Management", weight: 1 },
      { name: "Engineering Leadership", weight: 1 },
      { name: "Cross-functional Collaboration", weight: 0.9 },
      { name: "Agile Methodologies", weight: 0.8 }
    ],
    language: [
      { name: "SQL", weight: 0.8 },
      { name: "Python", weight: 0.7 },
      { name: "YAML", weight: 0.6 }
    ],
    tools: [
      { name: "Databricks", weight: 1 },
      { name: "Azure DevOps", weight: 1 },
      { name: "Unity Catalog", weight: 0.9 },
      { name: "Apache Spark", weight: 0.7 },
      { name: "Databricks Asset Bundles", weight: 0.7 },
      { name: "Azure", weight: 0.6 },
      { name: "Git", weight: 0.7 },
      { name: "Jupyter Notebooks", weight: 0.8 },
      { name: "Terraform", weight: 0.7 },
      { name: "PowerBI", weight: 0.6 }
    ]
  },
  goal: "Accelerate vehicle issue resolution through comprehensive data integration",
  detailsFile: "field-quality-use-case.md", // Reference to markdown file
  metrics: [
    "12 data sources successfully integrated"
  ],
  role: "Project Manager",
  teamSize: "5",
  git: "inner source",
  link: "inner source",
  isProfessional: true,
  isVisible: true
};
